import { render, staticRenderFns } from "./QuestionQuizInstruction.vue?vue&type=template&id=47b6ac36&scoped=true"
import script from "./QuestionQuizInstruction.vue?vue&type=script&lang=js"
export * from "./QuestionQuizInstruction.vue?vue&type=script&lang=js"
import style0 from "./QuestionQuizInstruction.vue?vue&type=style&index=0&id=47b6ac36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6ac36",
  null
  
)

export default component.exports